import { FC, ReactNode } from 'react';
import { RouteProps } from 'react-router-dom';
import { useTracking } from 'packages/lib/utils/hooks/use-tracking';
import { SWRConfig } from 'swr';
import { SecureSentryRoute } from 'packages/main/routes/components/sentry-route';

export const AnnotationToolRoute: FC<React.PropsWithChildren<RouteProps>> = ({
  children,
  ...rest
}) => {
  useTracking();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const renderRoute = (): ReactNode => {
    return <SWRConfig value={{ suspense: false }}>{children}</SWRConfig>;
  };

  return <SecureSentryRoute {...rest} render={renderRoute} />;
};
